<template>
  <div class="hr-resources-tab container">
    <h2 class="hr-resources-tab__title">Resource Center</h2>
    <div class="hr-resources-tab__desc">
      Educational resources to make your work easier
    </div>

    <div class="tab-content">
      <div class="tab-pane fade show active">
        <ul
          class="nav justify-content-center py-4 mx-auto"
        >
          <li class="nav-item col-4 p-0">
            <a
              class="nav-link"
              v-bind:class="{
                active: this.page === 'how-it-works',
              }"
              href="javascript:void(0);"
              @click="changePage('how-it-works')"
            >
              How It Works
            </a>
          </li>

        <li class="nav-item col-4 p-0">
            <a
              class="nav-link"
              v-bind:class="{ active: this.page === 'resources' }"
              href="javascript:void(0);"
              @click="changePage('resources')"
            >
              Resources
            </a>
          </li>

<!--          <li class="nav-item col-4 p-0">-->
<!--            <a-->
<!--              class="nav-link"-->
<!--              v-bind:class="{ active: this.page === 'product-info' }"-->
<!--              href="javascript:void(0);"-->
<!--              @click="changePage('product-info')"-->
<!--            >-->
<!--              Product Info-->
<!--            </a>-->
<!--          </li>-->

        </ul>
        <div class="tab-content mt-0">
          <div
            class="tab-pane fade px-lg-5"
            v-bind:class="{
              show: this.page === 'how-it-works',
              active: this.page === 'how-it-works',
            }"
          >
              <resource-list :type="'how_it_works'"></resource-list>
          </div>

            <div class="tab-content mt-0">
                <div
                    class="tab-pane fade px-lg-5"
                    v-bind:class="{
                        show: this.page === 'resources',
                        active: this.page === 'resources'
                    }"
                >
                    <resource-list :type="'resource'"></resource-list>
                </div>
            </div>
<!--          <div-->
<!--            class="tab-pane fade"-->
<!--            v-bind:class="{-->
<!--              show: this.page === 'product-info',-->
<!--              active: this.page === 'product-info',-->
<!--            }"-->
<!--          >-->
<!--            <div class="col text-center">-->
<!--              <h3>Work In Progress ...</h3>-->
<!--            </div>-->
<!--          </div>-->


        </div>
      </div>
    </div>

    <div class="row">
      <!-- <p v-if="resources.length == 0">No resources avaiable.</p> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: "how-it-works",
    };
  },

  computed: {
    noData() {
      return !this.resources.length;
    },
  },

  methods: {
    changePage(page) {
      this.page = page;
      window.location.hash = `#${page}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.hr-resources-tab {
  padding-top: 72px;
  margin-bottom: 72px;

  @media screen and (max-width: 768px) {
    margin-bottom: 100px;
  }

  &__title {
    color: #303030;
    font-family: Lato;
    font-size: 38px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 40px;
    text-align: center;
    @media (max-width: 768px) {
      text-align: left;
      font-size: 24px;
      font-family: "Open Sans", sans-serif;
    }
  }

  &__desc {
    color: #606064;
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 20px;
    text-align: center;
    @media (max-width: 768px) {
      text-align: left;
      font-size: 14px;
      font-family: "Open Sans", sans-serif;
    }
  }

  .tab-content {
    margin-top: 42px;

    .nav-link {
      font-family: Lato;
      font-size: 16px;
      font-weight: normal;
      letter-spacing: 0;
      line-height: 19px;
      text-align: center;
      border-bottom: 1px solid #D5D5D5;
      padding-bottom: 20px;
      color: #808fa4;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &.active {
        color: #313131;
        font-weight: bold;

        &::after {
          content: "";
          border-bottom: 4px solid #ff375e;
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    }
  }
}
</style>
